'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024189 from "./presto.types$$anon$189.js";
import * as $j_presto$002etypes$0024$0024anon$0024190 from "./presto.types$$anon$190.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$188() {
  this.c2k = null;
  this.c2i = null;
  this.c2j = false;
  this.c2g = null;
  this.c2h = false;
  this.c2l = false;
  this.c2m = false;
  this.c2k = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$$anon$188 as $c_Lpresto_types$$anon$188 };
$p = $c_Lpresto_types$$anon$188.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$188;
/** @constructor */
function $h_Lpresto_types$$anon$188() {
}
export { $h_Lpresto_types$$anon$188 as $h_Lpresto_types$$anon$188 };
$h_Lpresto_types$$anon$188.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.c2k;
});
$p.t = (function() {
  if ((!this.c2j)) {
    this.c2i = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("starts", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ends", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.c2j = true;
  }
  return this.c2i;
});
$p.ae = (function() {
  if ((!this.c2h)) {
    this.c2g = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002etypes$0024$0024anon$0024189.$c_Lpresto_types$$anon$189(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002etypes$0024$0024anon$0024190.$c_Lpresto_types$$anon$190(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.c2h = true;
  }
  return this.c2g;
});
$p.w = (function() {
  if ((!this.c2m)) {
    this.c2l = false;
    this.c2m = true;
  }
  return this.c2l;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$$anon$188 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$188, "presto.types$$anon$188", ({
  Y8: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$188 as $d_Lpresto_types$$anon$188 };
//# sourceMappingURL=presto.types$$anon$188.js.map
